export default __webpack_public_path__ + "static/media/image1.a385367f.png";